<div class="specialities">
    <div class="title">
        <div class="tit">
            <h3>ORVOSOK</h3>
            <div class="add-icon">
                <mat-icon routerLink="/adddoctor">add_circle</mat-icon>
            </div>
        </div>
    </div>

    <div class="add-new-speciality">
        <div class="search-bar">
            <div class="search-tool">
                <input type="search" placeholder="Orvos neve" [(ngModel)]="searchtText" />
                <div class="icon">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
                </div>
            </div>
        </div>
    </div>
    <div class="speciality-container">
        <div class="speciality-c">
            @for (doctor of doctors | filter: searchtText; track doctor; let i = $index) {
            <div class="speciality">
                <div class="pro">
                    <div class="name" [ngStyle]="
                                i % 2 === 0 ? { background: 'white', border: '1px solid #ccc' } : { background: '#efeff5', border: 'black' }
                            ">
                        <div routerLink="/doctor/{{ doctor.routerLink }}" class="button"
                            [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
                            {{ doctor.name }}
                        </div>
                        <mat-icon [ngStyle]="{ cursor: 'pointer' }"
                            (click)="openDeleteDoctorDialog(doctor)">delete_forever</mat-icon>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>